var _style, _g, _path, _circle, _path2, _path3, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 192.3",
    style: {
      enableBackground: "new 0 0 256 192.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.2-0.5H2.8C1.2-0.5,0,0.7,0,2.3V55c0,1.5,1.2,2.8,2.8,2.8h37V65h-8.6c-0.8,0-1.5,0.7-1.5,1.5 s0.7,1.5,1.5,1.5h27.6c0.8,0,1.5-0.7,1.5-1.5S59.6,65,58.8,65h-8.6v-7.2h37c1.5,0,2.8-1.2,2.8-2.8V2.3C90,0.7,88.8-0.5,87.2-0.5z  M87,54.8H3V2.5h84V54.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.7,99.6h39.8c3.3,0,5.9,2.7,5.9,5.9v30c0,3.3-2.7,5.9-5.9,5.9H38.7c-3.3,0-5.9-2.7-5.9-5.9v-30 C32.8,102.2,35.4,99.6,38.7,99.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 52.8,
    cy: 46.8,
    r: 20.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.6,99.6h39.8c3.3,0,5.9,2.7,5.9,5.9v30c0,3.3-2.7,5.9-5.9,5.9h-39.8c-3.3,0-5.9-2.7-5.9-5.9v-30 C100.6,102.2,103.3,99.6,106.6,99.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.4,99.6h39.8c3.3,0,5.9,2.7,5.9,5.9v30c0,3.3-2.7,5.9-5.9,5.9h-39.8c-3.3,0-5.9-2.7-5.9-5.9v-30 C168.5,102.2,171.2,99.6,174.4,99.6z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 39.5,
    y1: 81.9,
    x2: 213.4,
    y2: 81.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 90.7,
    y1: 56.9,
    x2: 189.6,
    y2: 56.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 90.7,
    y1: 32,
    x2: 211.4,
    y2: 32
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.330bfb486f591d63c3958cd5ac7b0e91.svg";
export { ForwardRef as ReactComponent };